/** The session list, its filter bar, and the per-session signal chips. */
const en = {
  title: 'Sessions',
  total: (n: string) => `${n} total`,
  filters: {
    source: 'Source',
    allSources: 'All sources',
    browser: 'Browser',
    allBrowsers: 'All browsers',
    os: 'OS',
    allOs: 'All OS',
    project: 'Project',
    allProjects: 'All projects',
    location: 'Location',
    country: 'country',
    minDuration: 'Min dur (s)',
    maxDuration: 'Max dur (s)',
    minActions: 'Min actions',
    hideCrawlers: 'Hide crawlers',
    hideCrawlersHint:
      'Hide known crawler / bot traffic (search engines, monitors, headless browsers, CLI clients)',
    clear: (n: number) => `Clear (${n})`,
    apply: 'Apply',
  },
  columns: {
    project: 'Project',
    user: 'User',
    source: 'Source',
    browserOs: 'Browser / OS',
    location: 'Location',
    duration: 'Duration',
    actions: 'Actions',
    signals: 'Signals',
    started: 'Started',
  },
  actionsHint: 'User actions (clicks, navigations, errors)',
  signals: {
    error: 'error',
    rage: 'rage',
    dead: 'dead',
    bounce: 'bounce',
    bot: 'bot',
  },
  empty: 'No sessions match these filters.',
  /** The per-project search screen, which has its own richer filter set. */
  search: {
    matches: (n: number) => `${n} match${n === 1 ? '' : 'es'}`,
    recent: (n: number) => `${n} recent`,
    userEmail: 'User (name, email or id)',
    urlContains: 'URL contains',
    any: 'Any',
    country: 'Country',
    customEvent: 'Custom event',
    minDuration: 'Min duration (s)',
    maxDuration: 'Max duration (s)',
    from: 'From',
    to: 'To',
    errors: 'Errors',
    rageClicks: 'Rage clicks',
    deadClicks: 'Dead clicks',
    consoleErrors: 'Console errors',
    searching: 'Searching…',
    applyFilters: 'Apply filters',
    url: 'URL',
    emptyTitle: 'No sessions captured yet',
    emptyBody: 'Install the ReplayOps SDK on your site to start recording sessions.',
    installSdk: 'Install the SDK',
  },
};

const tr: typeof en = {
  title: 'Oturumlar',
  total: (n: string) => `toplam ${n}`,
  filters: {
    source: 'Kaynak',
    allSources: 'Tüm kaynaklar',
    browser: 'Tarayıcı',
    allBrowsers: 'Tüm tarayıcılar',
    os: 'İşletim sistemi',
    allOs: 'Tüm işletim sistemleri',
    project: 'Proje',
    allProjects: 'Tüm projeler',
    location: 'Konum',
    country: 'ülke',
    minDuration: 'Min süre (sn)',
    maxDuration: 'Maks süre (sn)',
    minActions: 'Min eylem',
    hideCrawlers: 'Botları gizle',
    hideCrawlersHint:
      'Bilinen tarayıcı robotu / bot trafiğini gizler (arama motorları, izleme araçları, başsız tarayıcılar, komut satırı istemcileri)',
    clear: (n: number) => `Temizle (${n})`,
    apply: 'Uygula',
  },
  columns: {
    project: 'Proje',
    user: 'Kullanıcı',
    source: 'Kaynak',
    browserOs: 'Tarayıcı / İS',
    location: 'Konum',
    duration: 'Süre',
    actions: 'Eylem',
    signals: 'Sinyaller',
    started: 'Başlangıç',
  },
  actionsHint: 'Kullanıcı eylemleri (tıklama, gezinme, hata)',
  signals: {
    error: 'hata',
    rage: 'öfke',
    dead: 'ölü',
    bounce: 'hemen çıkma',
    bot: 'bot',
  },
  empty: 'Bu filtrelere uyan oturum yok.',
  search: {
    matches: (n: number) => `${n} eşleşme`,
    recent: (n: number) => `son ${n}`,
    userEmail: 'Kullanıcı (ad, e-posta veya kimlik)',
    urlContains: 'URL şunu içerir',
    any: 'Hepsi',
    country: 'Ülke',
    customEvent: 'Özel olay',
    minDuration: 'Min süre (sn)',
    maxDuration: 'Maks süre (sn)',
    from: 'Başlangıç',
    to: 'Bitiş',
    errors: 'Hatalar',
    rageClicks: 'Öfke tıklamaları',
    deadClicks: 'Ölü tıklamalar',
    consoleErrors: 'Konsol hataları',
    searching: 'Aranıyor…',
    applyFilters: 'Filtreleri uygula',
    url: 'URL',
    emptyTitle: 'Henüz kaydedilen oturum yok',
    emptyBody: 'Oturum kaydetmeye başlamak için ReplayOps SDK’sını sitenize kurun.',
    installSdk: 'SDK’yı kur',
  },
};

export const sessions = { en, tr };
